const BREAK_XXL = 1480;
const BREAK_XL = 1200;
const BREAK_LG = 1090;
const BREAK_MD = 900;
const BREAK_S = 540;
const BREAK_XS = 400;

$(document).on('beforeShow.fb', function( e, ins, slide ) { 
	let $link = slide.opts.$orig[0]; 
	if ($link){
		console.log(slide.opts.$orig[0])
		slide.opts.caption = slide.opts.$orig[0].getAttribute('data-caption') ? slide.opts.$orig[0].getAttribute('data-caption') : "";
	}
});

(function () {
	"use strict";

	if (document.querySelector("#form_id-2248 [name='email_address']"))
		document.querySelector("#form_id-2248 [name='email_address']").value =
			"email@gmail.com";

	// Constants
	const CLASS_NAME_SHOW$1 = "show";
	const CLASS_NAME_SHOW$2 = "active";
	const CLASS_NAME_SHOW$3 = "down";
	const CLASS_NAME_SHOW$4 = "up";
	const CLASS_NAME_SHOW$5 = "fixed";

	const SELECTOR_ELEMENT$1 = "#header.hero";

	let VALUE_SCROLL_TOP$1 = 0;
	let VALUE_SCROLL_TOP$2 = 80;

	// * weatherApi
	// *
	// * get current data of weahter Api

	const WEATHER_API_CONF = {
		target: "#weather_data",
		target_mobile: "#weather_data_mobile",
		targets: {
			booking: "#weather_data_booking",
		},
		api_key: "0ddd1af8b5b1833cedd6da7a90934cce",
		zip: "81435,us",
		lat: 37.94,
		lon: -107.8214,
		units: "imperial",
		getters: {
			// Coordinates by zip/post code
			coordinates: `https://api.openweathermap.org/geo/1.0/zip?zip={zip}&appid={api_key}`,
			// Call current weather data
			current_weather: `https://api.openweathermap.org/data/2.5/weather?lat={lat}&lon={lon}&appid={api_key}`,
		},
		url_icon: "https://openweathermap.org/img/wn/",
	};

	const weatherApi = () => {
		let weatherBox = document.querySelector(WEATHER_API_CONF.target);
		let weatherBoxBooking = document.querySelector(
			WEATHER_API_CONF.targets.booking
		);
		let weatherBoxMobile = document.querySelector(
			WEATHER_API_CONF.target_mobile
		);

		let urlApi = `${WEATHER_API_CONF.getters.current_weather}&units=${WEATHER_API_CONF.units}`;
		urlApi = urlApi.replace("{lat}", WEATHER_API_CONF.lat);
		urlApi = urlApi.replace("{lon}", WEATHER_API_CONF.lon);
		urlApi = urlApi.replace("{api_key}", WEATHER_API_CONF.api_key);

		fetch(urlApi)
			.then((response) => response.json())
			.then((data) => {
				let weatherIcon = data.weather[0].icon;
				let weatherTemp = Math.trunc(data.main.temp);
				let weatherHumidity = data.main.humidity;
				let weatherDescrip = data.weather[0].description;

				console.log(data);

				const documentRange = document.createRange();
				const stringHtml = `
					<div class="weather__temp" data-tb-tooltip>
						<div class="weather__temp--box">
							<div class="weather__temp--icon" style="background-image: url(${SITE_FILES}images/icons/weatherapi/${weatherIcon}.png);"></div>
							<div class="weather__temp--label">${weatherTemp} °F</div>
						</div>
						<div class="weather__temp--copy" data-tb-tooltip="text">${weatherDescrip}</div>
					</div>
					<div class="weather__line"></div>
					<div class="weather__humidity" data-tb-tooltip>
						<div class="weather__humidity--box">
							<div class="weather__humidity--label">${weatherHumidity} %</div>
						</div>
						<div class="weather__humidity--copy" data-tb-tooltip="text">Humidity</div>
					</div>
				`;

				if (weatherBox !== null) {
					const htmlFragmentBox =
						documentRange.createContextualFragment(stringHtml);
					weatherBox.appendChild(htmlFragmentBox);

					if (weatherBoxBooking !== null) {
						const htmlFragmentBooking =
							documentRange.createContextualFragment(stringHtml);
						weatherBoxBooking.append(htmlFragmentBooking);
					}
				}
				if (weatherBoxMobile !== null) {
					const htmlFragmentBoxMobile =
						documentRange.createContextualFragment(stringHtml);
					weatherBoxMobile.appendChild(htmlFragmentBoxMobile);
				}
			});
	};

	// * Functions of project
	// *
	// * Add functions of elements, components of HTML

	// scrollW - Check scroll down or up for header styles
	const scrollProps = {
		valueTopCurrent: 0,
		valueTop: 80,
		offsetTopNode: function (node, diff = 0) {
			if (node === null || node === "") return null;
			return node.offsetTop + diff;
		},
		top: function () {
			return window.pageYOffset || document.documentElement.scrollTop;
		},
	};

	const scrollW = () => {
		let SCROLL_TOP$1 = window.pageYOffset || document.documentElement.scrollTop;
		let HEADER = document.querySelector(SELECTOR_ELEMENT$1);

		if (SCROLL_TOP$1 > VALUE_SCROLL_TOP$2) {
			if (SCROLL_TOP$1 > VALUE_SCROLL_TOP$1) {
				/* Code - Down Scroll */
				onHide(HEADER, CLASS_NAME_SHOW$4);
				onShow(HEADER, CLASS_NAME_SHOW$3);
			} else {
				/* Code - up Scroll */
				onHide(HEADER, CLASS_NAME_SHOW$3);
				onShow(HEADER, CLASS_NAME_SHOW$4);
			}
		} else {
			onHide(HEADER, CLASS_NAME_SHOW$3);
			onHide(HEADER, CLASS_NAME_SHOW$4);
		}

		VALUE_SCROLL_TOP$1 = SCROLL_TOP$1 <= 0 ? 0 : SCROLL_TOP$1;
	};

	const scrollSticky = () => {
		let pagesWithSubNav = [
			"70893",
			"70865",
			"70877",
			"70875",
			"70873",
			"70871",
			"70885",
			"70887",
		];

		if (window.screen.width <= BREAK_MD && pagesWithSubNav.includes(page_id)) {
			let subNaveMobile = document.querySelector("#sub-nav--mobile");
			if (subNaveMobile === null) return null;

			let scrollTopNode = scrollProps.offsetTopNode(subNaveMobile, -118);
			let scrollTopDoc = scrollProps.top();
			let scrollTopCurrent = scrollProps.valueTopCurrent;

			if (scrollTopDoc > scrollTopNode) {
				onShow(subNaveMobile, CLASS_NAME_SHOW$5);

				if (scrollTopDoc > scrollTopCurrent) {
					onHide(subNaveMobile, CLASS_NAME_SHOW$4);
					onShow(subNaveMobile, CLASS_NAME_SHOW$3);
				} else {
					onHide(subNaveMobile, CLASS_NAME_SHOW$3);
					onShow(subNaveMobile, CLASS_NAME_SHOW$4);
				}
			} else {
				onHide(subNaveMobile, CLASS_NAME_SHOW$3);
				onHide(subNaveMobile, CLASS_NAME_SHOW$4);
				onHide(subNaveMobile, CLASS_NAME_SHOW$5);
			}

			scrollTopCurrent = scrollTopDoc <= 0 ? 0 : scrollTopDoc;
			scrollProps.valueTopCurrent = scrollTopCurrent;
		}
	};

	// * searchParams
	// *
	// * search params to url
	const searchParams = () => {
		if (window.location.search) {
			const URL = window.location.search.slice(1);
			let paramsURL = URL.split("&");

			paramsURL.forEach((param) => {
				let value = param.split("=")[0];
				let key = param.split("=")[1];

				// ?sld=quad_9wlths71d&sldgo=0

				switch (value) {
					case "qd": // option quad
						scrollQuad(key);
						break;
					case "sld": // option slider
						sliderGoTo(key);
						break;
					default:
				}
			});
		}
	};

	const scrollQuad = (selectorElement) => {
		if (selectorElement === null || selectorElement === "") return;

		let target = document.querySelector(`#${selectorElement}`);

		if (target === null) {
			target = document.querySelector(`.${selectorElement}`);
		}

		if (target === null) {
			target = document.querySelector(`[data-tb-quad="${selectorElement}"]`);
		}

		if (target === null) {
			console.error(
				`ERROR: there is no element with the class, id or data attribute "${selectorElement}"`
			);
			return;
		}

		$("html, body").animate({ scrollTop: $(target).offset().top - 100 }, 800);
	};

	const sliderGoTo = (selectorFiilter) => {
		if (selectorFiilter === null || selectorFiilter === "") return;

		let sliderId = selectorFiilter.split("/")[0];
		let sliderGoTo =
			selectorFiilter.split("/")[1] === null
				? 0
				: parseInt(selectorFiilter.split("/")[1]);

		let sliderElement = document.querySelector(`#${sliderId} [data-tb-slick]`);
		if (sliderElement === null) {
			console.error(`ERROR: it is not possible to slider the element`);
			return;
		}

		// scroll to quad parent
		let scrollSelect = onValidParam("quad");
		if (!scrollSelect) {
			onScrollAuto(sliderElement);
		}

		const $curSlider = $(`#${sliderId} [data-tb-slick]`);
		setTimeout(() => {
			$curSlider.slick("slickGoTo", sliderGoTo);
		}, 1000);
	};

	const onValidParam = (param) => {
		const URL = window.location.search.slice(1);

		if (URL.indexOf(param) === 0) return true;
		return false;
	};

	const onScrollAuto = (sourceSelector) => {
		let htmlQuad = sourceSelector.closest("[data-tb-quad]");
		let idQuad =
			htmlQuad.getAttribute("id") === null
				? htmlQuad.dataset.tbQuad
				: htmlQuad.getAttribute("id");

		scrollQuad(idQuad);
	};

	// * Focus
	// *
	// * Add class to parent element in to event required

	const FOCUS_ELEMENTS$1 = [
		"#email-signup_FNAME",
		"#email-signup_LNAME",
		"#email-signup_email_address",
	];
	const FOCUS_CLASS_NAME$1 = "focus";

	const focusParent = () => {
		FOCUS_ELEMENTS$1.forEach((element) => {
			let input = document.querySelector(element);
			if (input === null) return null;

			let parent_element;

			input.addEventListener("focus", function (event) {
				event.preventDefault();

				parent_element = input.parentElement;
				if (parent_element === null) return null;

				onShow(parent_element, FOCUS_CLASS_NAME$1);
			});

			input.addEventListener("blur", function (event) {
				if (input.value !== "") return null;

				event.preventDefault();

				parent_element = input.parentElement;
				if (parent_element === null) return null;

				onHide(parent_element, FOCUS_CLASS_NAME$1);
			});
		});
	};

	// * Toggle
	// *
	// * Collapse, Accordion and expand elements

	const TOGGLE_SELECTOR$1 = '[data-tb-toggle="collapse"]';
	const TOGGLE_SELECTOR$2 = '[data-tb-toggle="accordion"]';
	const TOGGLE_SELECTOR$3 = '[data-tb-toggle="dropdown-submenu"]';
	const TOGGLE_SELECTOR$4 = '[data-tb-toggle="tab"]';
	const TOGGLE_SELECTOR$5 = '[data-tb-toggle="hover"]';
	const TOGGLE_SELECTOR$6 = '[data-tb-toggle="hover-in"]';
	const TOGGLE_SELECTOR$7 = '[data-tb-toggle="hover-out"]';
	const TOGGLE_SELECTOR$8 = '[data-tb-toggle="dropdown"]';

	const TOGGLE_ATTRIBUTE$1 = "data-tb-target";
	const TOGGLE_ATTRIBUTE$2 = "[data-tb-accordion][aria-expanded=true]";

	const TOGGLE_CLASS_NAME$1 = "active";
	const TOGGLE_CLASS_NAME$2 = "show";
	const TOGGLE_CLASS_NAME$3 = "open";
	const TOGGLE_CLASS_NAME$4 = "hover";

	const collapse = () => {
		let collapse = document.querySelectorAll(TOGGLE_SELECTOR$1);

		collapse.forEach((element) => {
			let selector = getSelectorFromElement(element, TOGGLE_ATTRIBUTE$1);

			if (selector) {
				let target = document.querySelector(selector);

				element.addEventListener("click", function (event) {
					event.preventDefault();

					onToggle(target, TOGGLE_CLASS_NAME$2);
					onAriaHidden(target);

					onToggle(element, TOGGLE_CLASS_NAME$3);
					onAriaExpanded(element);

					// changes TabIndex of elements
					if (target.getAttribute("tabindex") === "-1") {
						target.setAttribute("tabindex", "0");
					} else {
						target.setAttribute("tabindex", "-1");
					}
				});
			}

			return null;
		});
	};

	const accordion = () => {
		let elements = document.querySelectorAll(TOGGLE_SELECTOR$2);

		elements.forEach((element) => {
			element.addEventListener("click", function () {
				onOpenAccordion(element);
			});
		});
	};

	const dropdownSubMenu = () => {
		let elements = document.querySelectorAll(TOGGLE_SELECTOR$3);
		let selector, target, targetText, childActive;

		elements.forEach((element) => {
			selector = getSelectorFromElement(element, TOGGLE_ATTRIBUTE$1);

			if (selector) {
				target = document.querySelector(selector);

				// childs target with class name active
				childActive = target.querySelector(`a.${TOGGLE_CLASS_NAME$1}`);
				if (childActive !== null) {
					childActive.addEventListener("click", function (event) {
						event.preventDefault();
					});
					targetText = childActive.textContent;
				}
				// updated text in anchor of dropdwon
				element.textContent = targetText;
			}

			element.addEventListener("click", function (event) {
				onToggle(target, TOGGLE_CLASS_NAME$3);
				onToggle(element, TOGGLE_CLASS_NAME$3);
			});
		});
	};

	const tabs = () => {
		let elementsTabs = document.querySelectorAll(TOGGLE_SELECTOR$4);

		elementsTabs.forEach((elementTab) => {
			elementTab.addEventListener("click", function (event) {
				event.preventDefault();

				onActiveTab(elementTab, elementsTabs);
			});

			// Initial tab
			if (elementTab.classList.contains(TOGGLE_CLASS_NAME$1))
				elementTab.click();
		});
	};

	const hover = () => {
		let elements = document.querySelectorAll(TOGGLE_SELECTOR$5);

		elements.forEach((element) => {
			let elementsIn = element.querySelectorAll(TOGGLE_SELECTOR$6);

			elementsIn.forEach((itemIn, index) => {
				let elementOut = element.querySelectorAll(TOGGLE_SELECTOR$7)[index];

				if (itemIn.classList.contains(TOGGLE_CLASS_NAME$2) && elementOut)
					onShow(elementOut, TOGGLE_CLASS_NAME$2);

				itemIn.addEventListener("mouseenter", () => {
					onShow(itemIn, TOGGLE_CLASS_NAME$4);
					if (elementOut) onShow(elementOut, TOGGLE_CLASS_NAME$4);
				});
				itemIn.addEventListener("mouseleave", () => {
					onHide(itemIn, TOGGLE_CLASS_NAME$4);
					if (elementOut) onHide(elementOut, TOGGLE_CLASS_NAME$4);
				});
			});
		});
	};

	const dropdown = () => {
		let elements = document.querySelectorAll(TOGGLE_SELECTOR$8);
		let selector, target;

		elements.forEach((element) => {
			element.addEventListener("click", function (event) {
				selector = getSelectorFromElement(element, TOGGLE_ATTRIBUTE$1);

				if (selector) {
					target = document.querySelector(selector);

					onToggle(target, TOGGLE_CLASS_NAME$2);
					onToggle(element, TOGGLE_CLASS_NAME$3);

					// WRAPPER JQUERY
					if (target.classList.contains(TOGGLE_CLASS_NAME$2)) {
						$(target).slideDown("slow");
					} else {
						$(target).slideUp("slow");
					}
				}
			});
		});
	};

	// * Overflow
	// *
	// * Overflow elements in event click
	const OVERFLOW_SELECTOR$1 = "[data-tb-overflow]";
	const OVERFLOW_ATTRIBUTE$1 = "data-tb-overflow";
	const OVERFLOW_CLASS_NAME$1 = "overflow-element";

	const overflow = () => {
		let overflow = document.querySelectorAll(`${OVERFLOW_SELECTOR$1}`);

		overflow.forEach((element) => {
			let selector = getSelectorFromElement(element, OVERFLOW_ATTRIBUTE$1);

			if (selector) {
				let target = document.querySelector(selector);

				element.addEventListener("click", function (event) {
					event.preventDefault();

					onToggle(target, OVERFLOW_CLASS_NAME$1);
				});
			}

			return null;
		});
	};

	// * Inner Texts
	// *
	// * Add texts to elements HTML

	// constants
	const INNER_TEXT_SELECTOR$1 = ".footer #email-signup";
	const INNER_TEXT_SELECTOR$2 = ".gdpr-wrap";
	const INNER_TEXT_SELECTOR$3 = "#attractions";
	const INNER_TEXT_ELEMENTS$1 = ["#signupformButton", ".pin-website", ".btn"];

	// movePoliciesForm - Move policies out of '.email-signup' form.
	const movePoliciesForm = () => {
		let FORM_MAIL = document.querySelector(INNER_TEXT_SELECTOR$1);
		let POLICIES =
			FORM_MAIL !== null
				? FORM_MAIL.querySelector(INNER_TEXT_SELECTOR$2)
				: null;

		if (FORM_MAIL !== null && POLICIES !== null) {
			FORM_MAIL.appendChild(POLICIES);
		}
	};

	// addSpan - Add span to elements
	const addSpan = () => {
		let attractions_page = document.querySelector(INNER_TEXT_SELECTOR$3);
		let elements, text_element, wrapEffect;

		if (attractions_page !== null) {
			setTimeout(() => {
				INNER_TEXT_ELEMENTS$1.forEach((selector) => {
					elements = document.querySelectorAll(selector);

					elements.forEach((element) => {
						wrapEffect = element.querySelector("span.wrap-effect");

						if (wrapEffect !== null) return;

						text_element = element.innerHTML;
						element.innerHTML =
							text_element + "<span class='wrap-effect'></span>";
					});
				});
			}, 1000);
		} else {
			setTimeout(() => {
				INNER_TEXT_ELEMENTS$1.forEach((selector) => {
					elements = document.querySelectorAll(selector);

					elements.forEach((element) => {
						text_element = element.innerHTML;
						element.innerHTML =
							text_element + "<span class='wrap-effect'></span>";
					});
				});
			}, 2500);
		}
	};

	// * Efect to button
	// *
	// * Effect button in website
	const EFFECT_ELEMENTS$1 = [
		"button.hero__link",
		"button.signup-btn",
		".btn",
		".pin-website",
	];
	const EFFECT_ELEMENT$1 = "span.wrap-effect";
	const EFFECT_ELEMENT$2 = "#attractions";
	const EFFECT_ELEMENT$3 = "[data-attraction]";
	const EFFECT_ELEMENT$4 = "#attraction-lightbox";

	const effectButton = () => {
		let attractions_page = document.querySelector(EFFECT_ELEMENT$2);
		let elements, lightbox;

		if (attractions_page !== null) {
			setTimeout(() => {
				let elements = document.querySelectorAll(EFFECT_ELEMENT$3);

				elements.forEach((element) => {
					element.addEventListener("click", function (event) {
						lightbox = document.querySelector(EFFECT_ELEMENT$4);

						if (lightbox === null) return;

						EFFECT_ELEMENTS$1.forEach((selector) => {
							elements = document.querySelectorAll(selector);

							onEffectButtons(elements, EFFECT_ELEMENT$1);
						});
					});
				});
			}, 2000);
		} else {
			setTimeout(() => {
				EFFECT_ELEMENTS$1.forEach((selector) => {
					elements = document.querySelectorAll(selector);

					onEffectButtons(elements, EFFECT_ELEMENT$1);
				});
			}, 3000);
		}
	};

	// * Animations to anchor
	// *
	// * Animate for elements anchor
	const ANIMATE_ANCHOR_ELEMENT$1 = "a[href*='#'][data-tb-animate='anchor']";
	const ANIMATE_ANCHOR_ATTRIBUTE$1 = "href";

	const animateAnchor = () => {
		let elements = document.querySelectorAll(ANIMATE_ANCHOR_ELEMENT$1);

		elements.forEach((element) => {
			let selector = getSelectorFromElement(
				element,
				ANIMATE_ANCHOR_ATTRIBUTE$1
			);

			if (selector === "" || selector === null) return;

			let target = document.querySelector(selector);
			element.addEventListener("click", function (event) {
				event.preventDefault();

				let offset = target.offsetParent.offsetTop;

				window.scrollTo({
					top: offset,
					behavior: "smooth",
				});
			});
		});
	};

	// * Scroll Efect
	// *
	// * Scroll efect to anchor
	const SCROLL_SELECTOR_DATA$1 = '[data-tb-scroll="scroll-down"]';

	const scrollDown = () => {
		let scrolldown = document.querySelectorAll(SCROLL_SELECTOR_DATA$1);

		scrolldown.forEach((element) => {
			let selector = getSelectorFromElement(element);

			if (selector) {
				let target = document.querySelector(selector);

				element.addEventListener("click", function (event) {
					event.preventDefault();

					// window.scrollTo({
					// 	top: 0,
					// 	behavior: 'smooth',
					// })

					$("html, body").animate(
						{ scrollTop: $(target).offset().top - 0 },
						800
					);
				});
			}

			return null;
		});
	};

	// * Rellax
	// *
	// * Effect with rellax of parallax

	const rellaxInit = () => {
		if (window.innerWidth > 820) {
			const rellax = new Rellax("[data-rellax]", { center: true });
		}
	};

	// * Slider By Slick
	// *
	// * Slider to project with library "Slick"
	const SLIDER_SELECTOR$1 = '[data-tb-slick="home"]';
	const SLIDER_SELECTOR$2 = '[data-tb-slick="slider-block"]';
	const SLIDER_SELECTOR$3 = '[data-tb-slick="slider-tabs-block"]';
	const SLIDER_SELECTOR$4 = '[data-tb-slick="reviews-block"]';
	const SLIDER_SELECTOR$5 = '[data-tb-slick="timeline-block"]';
	const SLIDER_SELECTOR$6 = '[data-tb-slick="rooms-block"]';
	const SLIDER_SELECTOR$7 = '[data-tb-slick="location-block"]';
	const SLIDER_SELECTOR$8 = '[data-tb-slick="gallery-block"]';
	const SLIDER_SELECTOR$9 = '[data-tb-slick="mobile-slider-tabs-block"]';
	const SLIDER_SELECTOR$10 = '[data-tb-slick="list-featured"]';

	const SLIDER_SPEED$1 = 5000; 

	// slickHome
	const slickHome = () => {
		$(SLIDER_SELECTOR$1).slick({
			fade: true,
			cssEase: "linear",
			arrows: false,
			dots: false,
			autoplay: true,			
			autoplaySpeed: SLIDER_SPEED$1
		});
	};

	// slickSlider
	const slickSlider = () => {
		
		let arrowsElement;

		$(SLIDER_SELECTOR$2).each(function() {
			arrowsElement = $(this).attr('data-tb-slick-arrows');
			$(this).slick({
				fade: true,
				cssEase: "linear",
				arrows: true,
				dots: false,
				autoplay: true,
				autoplaySpeed: SLIDER_SPEED$1,
				appendArrows: $(arrowsElement),
				responsive: [
					{
						breakpoint: BREAK_MD,
						settings: {
							arrows: true,
							adaptiveHeight: true,
							appendArrows: $(this),
						},
					},
					{
						breakpoint: BREAK_S,
						settings: {
							arrows: true,
							dots: true,
							autoplay: false,
							adaptiveHeight: true,
							appendArrows: $(this),
						},
					},
				],
			});
		})

		$(`${SLIDER_SELECTOR$2} [data-slick-goto]`).click(function () {
			const $curSlider = $(this).data("target")
				? $($(this).data("target"))
				: $(this).closest(SLIDER_SELECTOR$2);
			const target = $(this).data("slick-goto")
				? parseInt($(this).data("slick-goto"))
				: 0;

			$curSlider.slick("slickGoTo", target);
		});
	};

	// slickSliderTabs
	const slickSliderTabs = () => {
		let slickElements = document.querySelectorAll(SLIDER_SELECTOR$3);

		slickElements.forEach((element) => {
			let arrowsElement =
				element.dataset.tbSlickArrows !== undefined
					? element.dataset.tbSlickArrows
					: "#box-arrow";
			let arrowsBox = document.querySelector(arrowsElement);

			$(element).slick({
				fade: true,
				cssEase: "linear",
				arrows: true,
				dots: false,
				autoplay: true,
				autoplaySpeed: SLIDER_SPEED$1,
				appendArrows: arrowsBox,
				responsive: [
					{
						breakpoint: BREAK_S,
						settings: "unslick",
					},
				],
			});
		});
	};

	// slickSliderTabs
	const slickReviews = () => {
		let slickElements = document.querySelectorAll(SLIDER_SELECTOR$4);

		slickElements.forEach((element) => {
			let arrowsElement =
				element.dataset.tbSlickArrows !== undefined
					? element.dataset.tbSlickArrows
					: "#box-arrow";
			let arrowsBox = document.querySelector(arrowsElement);

			$(element).slick({
				fade: true,
				cssEase: "linear",
				arrows: true,
				dots: false,
				autoplay: true,
				autoplaySpeed: SLIDER_SPEED$1,
				appendArrows: arrowsBox,
				responsive: [
					{
						breakpoint: BREAK_S,
						settings: {
							arrows: false,
							dots: true,
							autoplay: false,
							adaptiveHeight: true,
						},
					},
				],
			});
		});
	};

	// slickTimeline
	const slickTimeline = () => {
		let slickElements = document.querySelectorAll(SLIDER_SELECTOR$5);

		slickElements.forEach((element) => {
			let arrowsElement =
				element.dataset.tbSlickArrows !== undefined
					? element.dataset.tbSlickArrows
					: "#box-arrow";
			let arrowsBox = document.querySelector(arrowsElement);

			$(element).slick({
				fade: true,
				cssEase: "linear",
				arrows: true,
				dots: false,
				appendArrows: arrowsBox,
				responsive: [
					{
						breakpoint: BREAK_MD,
						settings: {
							adaptiveHeight: true,
							appendArrows: $(element),
						},
					},
					{
						breakpoint: BREAK_S,
						settings: {
							fade: false,
							adaptiveHeight: true,
							appendArrows: $(element),
						},
					},
				],
			});
		});
	};

	// slickRooms
	const slickRooms = () => {
		let slickElements = document.querySelectorAll(SLIDER_SELECTOR$6);

		slickElements.forEach((element) => {
			let arrowsElement =
				element.dataset.tbSlickArrows !== undefined
					? element.dataset.tbSlickArrows
					: "#box-arrow";
			let arrowsBox = document.querySelector(arrowsElement);

			let dotsElement =
				element.dataset.tbSlickDots !== undefined
					? element.dataset.tbSlickDots
					: "#box-dots";
			let dotsBox = document.querySelector(dotsElement);

			$(element).slick({
				lazyLoad: "progressive",
				fade: true,
				cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
				arrows: true,
				dots: false,
				autoplay: false,
				appendArrows: arrowsBox,
				responsive: [
					{
						breakpoint: BREAK_MD,
						settings: {
							arrows: false,
							dots: true,
							appendDots: dotsBox,
						},
					},
				],
			});
		});
	};

	// slickLocation
	const slickLocation = () => {
		$(SLIDER_SELECTOR$7).slick({
			fade: true,
			cssEase: "linear",
			arrows: false,
			dots: false,
			adaptiveHeight: true,
			responsive: [
				{
					breakpoint: BREAK_S,
					settings: {
						adaptiveHeight: false,
					},
				},
			],
		});

		$(`.location-block [data-slick-goto]`).click(function () {
			const $curSlider = $(this).data("target")
				? $($(this).data("target"))
				: $(this).closest(SLIDER_SELECTOR$7);
			const target = $(this).data("slick-goto")
				? parseInt($(this).data("slick-goto"))
				: 0;

			$curSlider.slick("slickGoTo", target);
			$(this).siblings("[data-slick-goto]").removeClass("active");
			$(this).addClass("active");
		});
	};

	// slickGallery
	const slickGallery = () => {
		$(SLIDER_SELECTOR$8).slick({
			fade: true,
			cssEase: "linear",
			arrows: false,
			dots: true,
		});
	};

	// slickSliderTabs
	const slickSliderTabsMobile = () => {
		let slickElements = document.querySelectorAll(SLIDER_SELECTOR$9);

		slickElements.forEach((element) => {
			$(element).slick({
				fade: true,
				cssEase: "linear",
				arrows: false,
				dots: true,
				autoplay: false,
				autoplaySpeed: SLIDER_SPEED$1,
			});
		});
	};

	// slickListFeatured
	const slickListFeatured = () => {
		let slickElements = document.querySelectorAll(SLIDER_SELECTOR$10);

		slickElements.forEach((element) => {
			$(element).slick({
				fade: true,
				cssEase: "linear",
				arrows: false,
				dots: true,
				autoplay: true,
			});
		});
	};

	// * DatePicker
	// *
	// * Functions for datepciker in project

	const SELECTOR_DATEPICKER$1 = "#booking__calendars";

	const SELECTOR_DATE$1 = "#arrive";
	const SELECTOR_DATE$2 = "#depart";
	const SELECTOR_DATE$3 = "#checkInDate";
	const SELECTOR_DATE$4 = "#checkOutDate";

	let opened = 0;
	let start = $(SELECTOR_DATE$1).attr("value");
	let end = $(SELECTOR_DATE$2).attr("value");

	const datepickerBooking = () => {
		$(SELECTOR_DATEPICKER$1).datepicker({
			dateFormat: "yy-mm-dd",
			numberOfMonths: 1,
			minDate: new Date(),
			nextText: "",
			prevText: "",
			beforeShowDay: function (date) {
				$.datepicker._defaults.dateFormat = "yy-mm-dd";

				let startDate = $.datepicker.parseDate(
					$.datepicker._defaults.dateFormat,
					start
				);

				let endDate = $.datepicker.parseDate(
					$.datepicker._defaults.dateFormat,
					end
				);

				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (
							date.getTime() > startDate.getTime() &&
							date.getTime() < endDate.getTime()
						) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				let arrive = $.datepicker.parseDate(
					$.datepicker._defaults.dateFormat,
					start
				);
				let departure = $.datepicker.parseDate(
					$.datepicker._defaults.dateFormat,
					end
				);
				let selectedDate = $.datepicker.parseDate(
					$.datepicker._defaults.dateFormat,
					date
				);

				if (opened == 0) {
					opened = 1;
					start = date;
					end = date;
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						end = start;
						start = date;
					} else {
						end = date;
					}
				}

				$(SELECTOR_DATE$1).attr("value", start);
				$(SELECTOR_DATE$2).attr("value", end);

				let SplitArrive = start.split("-");
				let SplitDeparture = end.split("-");

				// Format date = Month / Day / Year
				$(SELECTOR_DATE$3).attr(
					"value",
					`${SplitArrive[1]}/${SplitArrive[2]}/${SplitArrive[0]}`
				);

				$(SELECTOR_DATE$4).attr(
					"value",
					`${SplitDeparture[1]}/${SplitDeparture[2]}/${SplitDeparture[0]}`
				);
			},
		});
	};

	// * Events Global Project
	// *
	// * Functions for menu, booking or quads
	const EVENTS_SELECTOR$1 = '[data-tb-target="#menu-nav"]';
	const EVENTS_SELECTOR$2 = '[data-tb-target="#booking-nav"]';
	const EVENTS_SELECTOR$3 = '[data-tb-target="#menu-nav"][data-tb-menu="open"]';
	const EVENTS_SELECTOR$4 =
		'[data-tb-target="#menu-nav"][data-tb-menu="close"]';
	const EVENTS_SELECTOR$5 =
		'[data-tb-target="#booking-nav"][data-tb-booking="open"]';
	const EVENTS_SELECTOR$6 =
		'[data-tb-target="#booking-nav"][data-tb-booking="close"]';
	const EVENTS_SELECTOR$7 =
		'.with-sub-menu nav.sub-menu li[class*="sn"] .active';
	const EVENTS_SELECTOR$8 = '[data-tb-event="hover-items"] [data-tb-hover]';
	const EVENTS_SELECTOR$9 =
		'[data-tb-pins="container"] [data-tb-pin="{{PIN_ID}}"]';
	const EVENTS_SELECTOR$10 = "#btn-web-cam";
	const EVENTS_SELECTOR$11 = "#header .hero__bottom";
	const EVENTS_SELECTOR$12 = "[data-slick-goto][data-target]";
	const EVENTS_HERO_ATTRIBUTE$2 = "data-tb-menu";
	const EVENTS_HERO_STATUS = { onOpen: "open", onClose: "close" };
	const EVENTS_HERO_CLASSNAME$1 = "open";
	const EVENTS_HERO_CLASSNAME$2 = "active";
	const EVENTS_HERO_CLASSNAME$3 = "hover";
	const EVENTS_HERO_CLASSNAME$4 = "close";

	// eventsMenu
	const eventsMenu = () => {
		let btnsMenu = document.querySelectorAll(EVENTS_SELECTOR$1);

		btnsMenu.forEach((btnMenu) => {
			btnMenu.addEventListener("click", function (event) {
				event.preventDefault();

				let statusMenu = btnMenu.dataset.tbMenu;

				if (statusMenu === EVENTS_HERO_STATUS.onClose) {
					let btnClose = document.querySelector(EVENTS_SELECTOR$3);

					if (btnClose === null) return null;

					onShow(btnClose, EVENTS_HERO_CLASSNAME$1);
					onChangesTabIndex("button", "-1", "0");
				}

				if (statusMenu === EVENTS_HERO_STATUS.onOpen) {
					let btnOpen = document.querySelector(EVENTS_SELECTOR$4);

					if (btnOpen === null) return null;

					onHide(btnOpen, EVENTS_HERO_CLASSNAME$1);
					onChangesTabIndex("button", "0", "-1");
				}
			});
		});
	};

	// eventsBooking
	const eventsBooking = () => {
		let btnsBooking = document.querySelectorAll(EVENTS_SELECTOR$2);

		btnsBooking.forEach((btnBooking) => {
			btnBooking.addEventListener("click", function (event) {
				event.preventDefault();

				let statusBooking = btnBooking.dataset.tbBooking;

				if (statusBooking === EVENTS_HERO_STATUS.onClose) {
					let btnClose = document.querySelector(EVENTS_SELECTOR$5);

					if (btnClose === null) return null;

					onShow(btnClose, EVENTS_HERO_CLASSNAME$1);
					onChangesTabIndex("button", "-1", "0");
				}

				if (statusBooking === EVENTS_HERO_STATUS.onOpen) {
					let btnOpen = document.querySelector(EVENTS_SELECTOR$6);

					if (btnOpen === null) return null;

					onHide(btnOpen, EVENTS_HERO_CLASSNAME$1);
					onChangesTabIndex("button", "0", "-1");
				}
			});
		});
	};

	// eventsSubMenu
	const eventsSubMenu = () => {
		let elements = document.querySelectorAll(EVENTS_SELECTOR$7);

		elements.forEach((element) => {
			onShow(element.parentElement, EVENTS_HERO_CLASSNAME$2);
		});
	};

	// eventsPropertyMap
	const eventsPropertyMap = () => {
		let itemsMap = document.querySelectorAll(EVENTS_SELECTOR$8); //items_map
		let target, parentBox, pinHover, pinSelector;

		itemsMap.forEach((item) => {
			parentBox = item.closest("[data-tb-quad]");

			item.addEventListener("mouseover", function (event) {
				target = event.target;

				if (target) {
					onShow(target, EVENTS_HERO_CLASSNAME$3);

					if (parentBox && target.dataset.tbHover !== undefined) {
						pinSelector = EVENTS_SELECTOR$9.replace(
							"{{PIN_ID}}",
							target.dataset.tbHover
						);
						pinHover = parentBox.querySelector(pinSelector);

						onShow(pinHover, EVENTS_HERO_CLASSNAME$3);
					}
				}
			});

			item.addEventListener("mouseout", function (event) {
				target = event.target;

				if (target) {
					onHide(target, EVENTS_HERO_CLASSNAME$3);

					if (parentBox && target.dataset.tbHover !== undefined) {
						pinSelector = EVENTS_SELECTOR$9.replace(
							"{{PIN_ID}}",
							target.dataset.tbHover
						);
						pinHover = parentBox.querySelector(pinSelector);

						onHide(pinHover, EVENTS_HERO_CLASSNAME$3);
					}
				}
			});
		});

		$(".heat-map__list-items ul li").mouseover(function () {
			for (let z = 0; z < itemsMap.length; z++) {
				if (this.dataset.tag == itemsMap[z].dataset.tag) {
					itemsMap[z].classList.add("active2");
				} else {
					itemsMap[z].classList.remove("active2");
				}
			}
		});
		$(".heat-map__list-items ul li").mouseout(function () {
			for (let z = 0; z < points_map.length; z++) {
				itemsMap[z].classList.remove("active2");
			}
		});
	};

	// eventsWebCam
	const eventsWebCam = () => {
		let buttonWebCam = document.querySelector(EVENTS_SELECTOR$10);

		if (buttonWebCam === null) return;

		buttonWebCam.addEventListener("click", function (event) {
			let target = event.target;
			let menuBottom = document.querySelector(EVENTS_SELECTOR$11);

			if (target && target.dataset.tbText !== undefined) {
				if (menuBottom !== null) {
					onToggle(menuBottom, EVENTS_HERO_CLASSNAME$4);
				}

				if (target.dataset.tbText === "Web Cam") {
					target.setAttribute("data-tb-text", "Close Web Cam");
				} else {
					target.setAttribute("data-tb-text", "Web Cam");
				}
			}
		});
	};

	// eventsSlickGoTo
	const eventsSlickGoTo = () => {
		let elements = document.querySelectorAll(EVENTS_SELECTOR$12);

		elements.forEach((element) => {
			element.addEventListener("click", function (event) {
				let target = event.target;

				if (target) {
					const targetSlider = target.dataset.target;
					const $goToSlider = $(target).data("slick-goto")
						? parseInt($(target).data("slick-goto"))
						: 0;
					const $curSlider = $(targetSlider);
					$curSlider.slick("slickGoTo", $goToSlider);
				}
			});
		});
	};

	// * Loader
	// *
	// * Functions of loader
	const initialLoader = () => {
		const switchLoader = document.querySelector("#loader");

		setTimeout(() => {
			onHide(switchLoader, "loader--initial");
			onShow(switchLoader, "loader--close");
			switchLoader.setAttribute("aria-hidden", true);
		}, 2000);
	};

	// * Checkbox to season
	// *
	// * Functions, Methods and changes to season
	const SEASON_SELECTOR$1 = "img[data-tb-replace-images]";
	const SEASON_SELECTOR$2 =
		"figure[data-tb-replace-images], div[data-tb-replace-images]";
	const SEASON_SELECTOR$3 = "[data-tb-filter]";
	const SEASON_SELECTOR$4 = "video source[data-tb-replace-videos]";
	const SEASON_CLASSNAME = "season-checked";
	const SEASON_CONTAINER = "#toogle-season";
	const SEASON_LOADER = "#loader";
	const SEASON_STATUS = {
		currentStatus: "summer",
		initStatus: "",
		status: {
			onSummer: "summer",
			onWinter: "winter",
		},
		loader: 0,
	};

	const seasonInitStatus = () => {
		// Create item to storage
		if (sessionStorage.getItem("season-status") === null) {
			sessionStorage.setItem(
				"season-status",
				document.body.dataset.tbSeasonTheme
			);
		}

		// cheked to button
		let initialStatus =
			sessionStorage.getItem("season-status") === CURRENT_SEASON
				? sessionStorage.getItem("season-status")
				: CURRENT_SEASON;
		let switchTheme = document.querySelector(SEASON_CONTAINER);
		let filterElement = document.querySelectorAll(SEASON_SELECTOR$3);

		switch (initialStatus) {
			case "summer":
				setTimeout(() => {
					// change in items to list of filter
					filterElement.forEach((item) => {
						if (item.dataset.tbSeason === initialStatus) {
							item.removeAttribute("hidden");
							item.setAttribute("aria-hidden", false);
						} else {
							item.setAttribute("hidden", true);
							item.setAttribute("aria-hidden", true);
						}
					});
					SEASON_STATUS.loader++;
				}, 180);

				break;

			case "winter":
				if (switchTheme.checked === false) {
					setTimeout(() => {
						switchTheme.click();
						SEASON_STATUS.loader++;
					}, 180);
				} else {
					switchTheme.click();
					setTimeout(() => {
						handlerImages();
					}, 180);
				}
				break;

			default:
				break;
		}

		SEASON_STATUS.initStatus = initialStatus;
		SEASON_STATUS.currentStatus = initialStatus;
	};

	const seasonSwitch = () => {
		let switchTheme = document.querySelector(SEASON_CONTAINER);
		let switchLoader = document.querySelector(SEASON_LOADER);

		if (switchTheme === null) return null;

		switchTheme.addEventListener("click", function (event) {
			// disabled input of toggle season
			switchTheme.disabled = true;

			// change colors of theme
			document.body.dataset.tbSeasonTheme =
				document.body.dataset.tbSeasonTheme === SEASON_STATUS.status.onSummer
					? SEASON_STATUS.status.onWinter
					: SEASON_STATUS.status.onSummer;

			// updated status season in storage
			sessionStorage.setItem(
				"season-status",
				document.body.dataset.tbSeasonTheme
			);

			SEASON_STATUS.currentStatus = document.body.dataset.tbSeasonTheme;

			// change season in attribute data of body
			onToggle(switchTheme.parentElement, SEASON_CLASSNAME);

			// init loader for changes season
			onHide(switchLoader, "loader--close");
			onShow(switchLoader, "loader--output");

			// remove class and attributes for changes season
			setTimeout(() => {
				switchTheme.disabled = false;

				onHide(switchLoader, "loader--output");
				onShow(switchLoader, "loader--close");
			}, 2000);
		});
	};

	const drawMapLines = () => {
		let x1, y1, x2, y2;
	
		let locationSeason = document.querySelectorAll('[data-tb-season]');
	
		function getOffset( el ) {
			let rect = el.getBoundingClientRect();
			return {
				left: rect.left + window.pageXOffset,
				top: rect.top + window.pageYOffset,
			};
		}
	
		locationSeason.forEach(location => {
			location.querySelectorAll('[data-path] .location-block__pin-icon').forEach((pin, i) => {
	
				x1 = getOffset(pin).left;
				y1 = getOffset(pin).top;
	
				let toPin = location.querySelectorAll('[data-path]')[i + 1] ? location.querySelectorAll('[data-path]')[i + 1].querySelector('.location-block__pin-icon') : null;
	
				let length = () => {
					return Math.sqrt(((x2-x1) * (x2-x1)) + ((y2-y1) * (y2-y1)));
				}
	
				let rotation = () => {
					return Math.atan2((y1-y2),(x1-x2))*(180/Math.PI)
				}
	
				if (toPin) {
					x2 = getOffset(toPin).left;
					y2 = getOffset(toPin).top;
		
					pin.querySelector('.location-block__pin-path').style.cssText = `
						width: ${length()}px;
						transform: translateX(-100%) rotate(${rotation()}deg);
					`;
				}
			});	
		})
	};

	const seasonChange = () => {
		let switchTheme = document.querySelector(SEASON_CONTAINER);

		if (switchTheme === null) return null;

		switchTheme.addEventListener("change", function (event) {
			handlerImages();

			// Reset Slick Slider Home Map
			setTimeout(() => {
				$(SLIDER_SELECTOR$7).slick('unslick');
			}, 1000);

			setTimeout(() => {
				// DRAW HOME MAP LINES AFTER LOADER ANIMATION
				drawMapLines();
				// Restart Slick Slider Home Map
				slickLocation();
			}, 1500);
		});
	};

	const handlerImages = () => {
		
		
		let imgImages = document.querySelectorAll(SEASON_SELECTOR$1);
		let figureImages = document.querySelectorAll(SEASON_SELECTOR$2);
		let filterElement = document.querySelectorAll(SEASON_SELECTOR$3);
		let sourceVideos = document.querySelectorAll(SEASON_SELECTOR$4);
		let imgByFigure, imgByFancy;
		let timeChange;
		if (SEASON_STATUS.loader === 0) timeChange = 400;
		else timeChange = 700;

		SEASON_STATUS.loader++;

		setTimeout(() => {
			// change videos to video>source tag
			sourceVideos.forEach((video) => {
				let videoElement = video.parentElement;

				if (
					!video.dataset.tbReplaceVideoWinter &&
					document.body.dataset.tbSeasonTheme === SEASON_STATUS.status.onWinter
				) {
					videoElement.style.display = "none";

					if (!videoElement.paused) {
						videoElement.pause();
					}
				} else {
					videoElement.style.display = "block";

					videoElement.load();
					videoElement.play();
				}

				if (video.dataset.tbReplaceVideoWinter) {
					video.setAttribute(
						"src",
						document.body.dataset.tbSeasonTheme ===
							SEASON_STATUS.status.onSummer
							? video.dataset.tbReplaceVideoSummer
							: video.dataset.tbReplaceVideoWinter
					);

					let playVideo = videoElement.play();

					if (playVideo !== undefined) {
						playVideo
							.then((_) => {
								// Automatic playback started!
								// Show playing UI.
							})
							.catch((error) => {
								console.warn(`Error: ${error}`);
							});
					}
				}
			});

			// changes images to img tag
			imgImages.forEach((image) => {
				image.setAttribute(
					"src",
					document.body.dataset.tbSeasonTheme === SEASON_STATUS.status.onSummer
						? image.dataset.tbReplaceImageSummer
						: image.dataset.tbReplaceImageWinter
				);
			});

			// change images to img in figure tag with lazyload
			figureImages.forEach((figure) => {
				imgByFancy =
					figure.querySelector("a[data-fancybox]") !== null
						? figure.querySelector("a[data-fancybox]")
						: null;

				if (imgByFancy !== null) {
					imgByFancy.setAttribute(
						"href",
						document.body.dataset.tbSeasonTheme ===
							SEASON_STATUS.status.onSummer
							? figure.dataset.tbReplaceImageSummer
							: figure.dataset.tbReplaceImageWinter
					);
				}

				imgByFigure =
					figure.querySelector("img[data-srcset], img[loading='lazy']") !== null
						? figure.querySelector("img[data-srcset], img[loading='lazy']")
						: figure.querySelector("img[data-tb-placeholder]");

				if (imgByFigure !== null) {

					let a_internal = figure.querySelector("a");
					if( a_internal ){
						a_internal.setAttribute(
							"data-caption",
							document.body.dataset.tbSeasonTheme ===
							SEASON_STATUS.status.onSummer
							? a_internal.dataset.captionSummer
							: a_internal.dataset.captionWinter
						)
					}

					imgByFigure.setAttribute(
						"src",
						document.body.dataset.tbSeasonTheme ===
							SEASON_STATUS.status.onSummer
							? figure.dataset.tbReplaceImageSummer
							: figure.dataset.tbReplaceImageWinter
					);
					imgByFigure.setAttribute(
						"data-srcset",
						document.body.dataset.tbSeasonTheme ===
							SEASON_STATUS.status.onSummer
							? figure.dataset.tbReplaceImageSummer
							: figure.dataset.tbReplaceImageWinter
					);

				} else {
					console.warn("No updated image to season");
				}
			});

			let counterIndex = 0;
			// change in items to list of filter
			filterElement.forEach((item, index) => {
				if (item.dataset.tbSeason === "") {
					item.removeAttribute("hidden");
					item.setAttribute("aria-hidden", false);
				} else if (
					item.dataset.tbSeason.includes(SEASON_STATUS.currentStatus)
				) {
					item.removeAttribute("hidden");
					item.setAttribute("aria-hidden", false);
				} else if (item.dataset.tbSeason === SEASON_STATUS.currentStatus) {
					item.removeAttribute("hidden");
					item.setAttribute("aria-hidden", false);
				} else {
					item.setAttribute("hidden", true);
					item.setAttribute("aria-hidden", true);
				}

				if (window.screen.width >= BREAK_LG) {
					onHide(item, "d-flex");
					onHide(item, "row");
					onHide(item, "row-rev");

					if (!item.hasAttribute("hidden")) {
						counterIndex++;
						onShow(item, "d-flex");

						if (counterIndex % 2 === 0) {
							onShow(item, "row-rev");
						} else {
							onShow(item, "row");
						}
					}
				}
			});

			filterSpecialBlocksByTypeAndSeason();

			const specialBlockFilter = document.querySelectorAll('.specials-block .specials-block__filter li');

			if (specialBlockFilter) {
				specialBlockFilter.forEach(singleBtn => {
					singleBtn.addEventListener('click', () => {
						specialBlockFilter.forEach(btn => btn.classList.remove('active'));
						singleBtn.classList.add('active');
						filterSpecialBlocksByTypeAndSeason();
					});
				});
			}

			function filterSpecialBlocksByTypeAndSeason() {
				let specialBlockFilterFilt = document.querySelectorAll('.specials-block .specials-block__filter li');
				
				let blocksToChange = document.querySelectorAll('.specials-block__item');
				let currentSeason = SEASON_STATUS.currentStatus;
						
				if (specialBlockFilterFilt.length < 1 || !blocksToChange) return;
						
				let activeBtn = Array.from(specialBlockFilterFilt).find(btn => btn.classList.contains('active'));
				let selectedType = activeBtn ? activeBtn.dataset.type : null;
						
				blocksToChange.forEach(item => {
				const itemType = item.dataset.type;
				const itemSeason = item.dataset.tbSeason;

				const matchesType = selectedType === null || itemType === selectedType;

				const matchesSeason =
					!itemSeason || itemSeason.trim() === "" || itemSeason === currentSeason;

				if (matchesType && matchesSeason) {
					item.removeAttribute("hidden");
					item.setAttribute("aria-hidden", false);
				} else {
					item.setAttribute("hidden", true);
					item.setAttribute("aria-hidden", true);
				}
			});

			}

		}, timeChange);
	};
	handlerImages();

	// * Observer
	// *
	// * Observer events for animations o actions
	const OBSERVER_CONFIG = {
		targets: {
			image: "[data-tb-observer='image-scale']",
		},
		classnames: {
			image_scale: "visible-image-scale",
		},
	};

	const observerAnimationImage = () => {
		let elements = document.querySelectorAll(OBSERVER_CONFIG.targets.image);

		let optionsObserver = {
			root: null,
			rootMargin: "0px",
			threshold: 0.3,
		};

		function callbackObserver(entries, observer) {
			for (let entry of entries) {
				if (entry.isIntersecting) {
					onShow(entry.target, OBSERVER_CONFIG.classnames.image_scale);
				}
			}
		}

		elements.forEach((element) => {
			let observerP = new IntersectionObserver(
				callbackObserver,
				optionsObserver
			);
			observerP.observe(element);
		});
	};

	// * Content Loaded
	// *
	// * DOM Content Loaded is ready available
	// * @param {*} callback

	const onDOMLoaded = (callback) => {
		if (
			document.readyState === "complete" ||
			document.readyState === "interactive"
		) {
			document.addEventListener("DOMContentLoaded", () => {
				setTimeout(callback, 1);
			});
		} else {
			document.addEventListener("DOMContentLoaded", callback);
		}
	};

	 //menus
	document.querySelectorAll('.js-menu-tab').forEach(function(btn) {
		btn.addEventListener('click', function() {
		  $('.js-menu-tab.active').removeClass('active');
		  $(btn).addClass('active');
		  $('.quad-menus__menu-content.active').removeClass('active');
		  const tabNumber = $(btn).attr('data-menuid');
		  const tabToOpen = ".quad-menus__menu-content[data-menuid='" + tabNumber + "']";
		  $(tabToOpen).addClass('active');
		  $('.quad-menus__tabs-image.active').removeClass('active');
		  const imgToOpen = ".quad-menus__tabs-image[data-menuid='" + tabNumber + "']";
		  $(imgToOpen).addClass('active');
		  $('.name-bg.active').removeClass('active');
		  const wordToOpen = ".name-bg[data-menuid='" + tabNumber + "']";
		  $(wordToOpen).addClass('active');
		});
	  });


	onDOMLoaded(
		// * This function add a class to header when scroll down the page
		// * and change the logo by a new file if needed depending of mockup

		scrollW(),
		scrollSticky(),
		window.addEventListener("scroll", function () {
			scrollW();
			scrollSticky();
		}),
		
		// DRAW HOME MAP LINES ON FIRST LOAD
		drawMapLines(),

		// api
		weatherApi(),

		// Scroll
		scrollDown(),

		// rellax
		rellaxInit(),

		// Inner text
		movePoliciesForm(),
		addSpan(),

		// Effect
		effectButton(),

		// Animation anchor
		animateAnchor(),

		// searchParams
		searchParams(),

		// Focus
		focusParent(),

		// Toggle
		collapse(),
		accordion(),
		dropdownSubMenu(),
		tabs(),
		hover(),
		dropdown(),

		// Overflow
		overflow(),

		// Slider with swiper
		slickHome(),
		slickSlider(),
		slickSliderTabs(),
		slickReviews(),
		slickTimeline(),
		slickRooms(),
		slickLocation(),
		slickGallery(),
		slickSliderTabsMobile(),
		slickListFeatured(),

		// datepicker
		datepickerBooking(),

		// eventsGlobal
		eventsMenu(),
		eventsBooking(),
		eventsSubMenu(),
		eventsPropertyMap(),
		eventsWebCam(),
		eventsSlickGoTo(),

		// loader
		initialLoader(),

		// CHeckbox to Season
		seasonInitStatus(),
		seasonChange(),
		seasonSwitch(),

		// observer
		observerAnimationImage()
	);
})();

